module.exports = {"TXTWCL_Claim_your_bonus":{"id":"TXTWCL_Claim_your_bonus","defaultMessage":"Διεκδίκησε το μπόνους σου","track":"Claim your bonus"}}